// import drawLine from './draw-line-on-circle'

// const prevent = e => e.preventDefault()

const drawCircle = (
  opacity,
  textColor,
  NS,
  mainAngle,
  pointsOnCircle,
  element,
  size,
  r,
  textOffset,
  dotSize,
  onLinkHover = () => {}
) => {
  const svg = document.createElementNS(NS, 'svg')
  element.appendChild(svg)
  svg.setAttribute('viewBox', `0 0 ${size} ${size}`)

  const bigCircle = document.createElementNS(NS, 'circle')
  bigCircle.setAttribute('cx', size / 1.9)
  bigCircle.setAttribute('cy', size / 1.9)
  bigCircle.setAttribute('fill', 'none')
  bigCircle.setAttribute('stroke', '#BD9973')
  bigCircle.setAttribute(
    'class',
    'circle__inner-circle circle__inner-circle--big'
  )
  bigCircle.setAttribute('r', r)
  svg.appendChild(bigCircle)

  const midCircle = document.createElementNS(NS, 'circle')
  midCircle.setAttribute('opacity', opacity / 5)
  midCircle.setAttribute('cx', size / 2)
  midCircle.setAttribute('cy', size / 2.1)
  midCircle.setAttribute('fill', 'none')
  midCircle.setAttribute('stroke', 'currentColor')
  midCircle.setAttribute(
    'class',
    'circle__inner-circle circle__inner-circle--mid'
  )
  midCircle.setAttribute('r', r)
  svg.appendChild(midCircle)

  const smallCircle = document.createElementNS(NS, 'circle')
  smallCircle.setAttribute('opacity', opacity / 2)
  smallCircle.setAttribute('cx', size / 2.1)
  smallCircle.setAttribute('cy', size / 1.9)
  smallCircle.setAttribute('fill', 'none')
  smallCircle.setAttribute('stroke', 'currentColor')
  smallCircle.setAttribute(
    'class',
    'circle__inner-circle circle__inner-circle--small'
  )
  smallCircle.setAttribute('r', r)
  svg.appendChild(smallCircle)

  // it only draws an unnecessary animation
  // const hideCircle = document.createElementNS(NS, 'circle')
  // hideCircle.setAttribute('opacity', 1)
  // hideCircle.setAttribute('cx', size / 2.1)
  // hideCircle.setAttribute('cy', size / 1.9)
  // hideCircle.setAttribute('fill', 'none')
  // hideCircle.setAttribute('stroke', 'currentColor')
  // hideCircle.setAttribute(
  //   'class',
  //   'circle__inner-circle circle__inner-circle--small'
  // )
  // hideCircle.setAttribute('r', r)
  // svg.appendChild(hideCircle)

  // const hideCircleLength =
  //   'getTotalLength' in hideCircle ? hideCircle.getTotalLength() : 0

  // hideCircle.style.strokeDasharray = `${hideCircleLength}px ${hideCircleLength}px`
  // hideCircle.style.strokeDashoffset = `${hideCircleLength}px`
  // hideCircle.style.transform = 'rotate(-90deg)'
  // hideCircle.style.transformOrigin = `${size / 2.1}px ${size / 1.9}px`
  // hideCircle.style.transition = 'stroke-dashoffset 0.7s ease-in-out'

  pointsOnCircle.forEach((data, index) => {
    const cos = Math.cos(+data.dataset.circleAngle)
    const sin = Math.sin(+data.dataset.circleAngle)
    const textClass =
      cos > 0 ? 'circle__svg-text--right' : 'circle__svg-text--left'
    const groupClass = cos > 0 ? 'circle__group--right' : 'circle__group--left'
    let link
    if (data.dataset.circleLink && data.dataset.circleLink !== '#') {
      link = document.createElementNS(NS, 'a')
      link.setAttribute('href', data.dataset.circleLink)
    } else {
      link = document.createElementNS(NS, 'g')
    }

    link.setAttribute(
      'class',
      `circle__link show-for-medium fade-in delay-${index * 100}`
    )
    svg.appendChild(link)
    link.addEventListener('mouseenter', () =>
      onLinkHover(data.dataset.circleTitle)
    )

    const pointX = size / 2.1 + r * cos
    const pointY = size / 1.9 + r * sin

    const point = document.createElementNS(NS, 'circle')
    point.setAttribute('cx', pointX)
    point.setAttribute('cy', pointY)
    point.setAttribute('r', dotSize)
    point.setAttribute('fill', 'currentColor')
    point.setAttribute('class', 'circle__dot')
    link.appendChild(point)

    const circlePoint = document.createElementNS(NS, 'circle')
    circlePoint.setAttribute('cx', pointX)
    circlePoint.setAttribute('cy', pointY)
    circlePoint.setAttribute('r', 3)
    circlePoint.setAttribute('fill', 'transparent')
    circlePoint.setAttribute('transform-origin', `${pointX}px ${pointY}px`)
    circlePoint.setAttribute('stroke', 'currentColor')
    circlePoint.setAttribute('stroke-width', '0.1px')
    circlePoint.setAttribute('class', 'circle__dot-big')
    link.appendChild(circlePoint)

    const groupX = size / 2.1 + (r + textOffset) * cos
    const groupY = size / 1.9 + (r + textOffset) * sin

    const textAnchor = cos > 0 ? 'start' : 'end'

    const group = document.createElementNS(NS, 'g')
    group.setAttribute('x', groupX)
    group.setAttribute('y', groupY)
    group.setAttribute('class', `circle__group ${groupClass}`)
    link.appendChild(group)

    const text = document.createElementNS(NS, 'text')

    text.textContent = data.dataset.circleTitle
    text.setAttribute('x', groupX)
    text.setAttribute('y', groupY)
    text.setAttribute('text-anchor', textAnchor)
    text.setAttribute('fill', textColor)
    text.setAttribute(
      'class',
      `circle__svg-text circle__svg-text--${element.dataset.circle} ${textClass}`
    )
    link.setAttribute('data-angle', `${data.dataset.circleAngle}`)
    group.appendChild(text)

    if (data.amount) {
      const amount = document.createElementNS(NS, 'tspan')
      amount.textContent = `${data.amount} `
      amount.setAttribute('class', `circle__svg-amount ${textClass}`)
      text.prepend(amount)
    }

    const line = document.createElementNS(NS, 'rect')

    const lineOrigin =
      cos > 0 ? `${groupX}px ${groupY + 10}px` : `${groupX}px ${groupY + 10}px`

    const linePositionX = cos > 0 ? groupX : groupX - textOffset

    line.setAttribute('x', linePositionX)
    line.setAttribute('y', groupY + 10)
    line.setAttribute('stroke', '#fff')
    line.setAttribute('fill', 'transparent')
    line.setAttribute('width', '5%')
    line.setAttribute('height', '1')
    line.setAttribute('transform-origin', lineOrigin)
    line.setAttribute('class', 'circle__svg-line')
    group.appendChild(line)
  })

  // drawLine(hideCircle, r, mainAngle)
  element.dataset.elementAnimate = ''
}

export default drawCircle
